export class SimpleTextInfo {
  Value: string
}
